"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent, forwardingNumberId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.forwardingNumberId = forwardingNumberId;
    }
    path(withParameter = true) {
        if (withParameter && this.forwardingNumberId !== null) {
            return `${this.parent.path()}/forwarding-number/${this.forwardingNumberId}`;
        }
        return `${this.parent.path()}/forwarding-number`;
    }
    /**
     * Returns the list of extension phone numbers used for call forwarding
   * and call flip. The returned list contains all the extension phone numbers
   * used for call forwarding and call flip.
   *
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadUserForwardingFlipNumbers
     */
    async list(queryParams, restRequestConfig) {
        const r = await this.rc.get(this.path(false), queryParams, restRequestConfig);
        return r.data;
    }
    /**
     * Adds a new forwarding number to the forwarding number list.
     * HTTP Method: post
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserForwardingFlipNumbers
     */
    async post(createForwardingNumberRequest, restRequestConfig) {
        const r = await this.rc.post(this.path(false), createForwardingNumberRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes multiple forwarding numbers from the forwarding number list by IDs.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserForwardingFlipNumbers
     */
    async deleteAll(deleteForwardingNumbersRequest, restRequestConfig) {
        const r = await this.rc.delete(this.path(false), deleteForwardingNumbersRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Returns a specific forwarding number.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number/{forwardingNumberId}
     * Rate Limit Group: Light
     * App Permission: ReadAccounts
     * User Permission: ReadUserForwardingFlipNumbers
     */
    async get(restRequestConfig) {
        if (this.forwardingNumberId === null) {
            throw new Error('forwardingNumberId must be specified.');
        }
        const r = await this.rc.get(this.path(), undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Updates the existing forwarding number from the forwarding number list.
     * HTTP Method: put
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number/{forwardingNumberId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserForwardingFlipNumbers
     */
    async put(updateForwardingNumberRequest, restRequestConfig) {
        if (this.forwardingNumberId === null) {
            throw new Error('forwardingNumberId must be specified.');
        }
        const r = await this.rc.put(this.path(), updateForwardingNumberRequest, undefined, restRequestConfig);
        return r.data;
    }
    /**
     * Deletes a forwarding number from the forwarding number list by its ID.
     * HTTP Method: delete
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/forwarding-number/{forwardingNumberId}
     * Rate Limit Group: Medium
     * App Permission: EditExtensions
     * User Permission: EditUserForwardingFlipNumbers
     */
    async delete(restRequestConfig) {
        if (this.forwardingNumberId === null) {
            throw new Error('forwardingNumberId must be specified.');
        }
        const r = await this.rc.delete(this.path(), undefined, restRequestConfig);
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map